module.exports = __webpack_public_path__ + "static/media/icnProxPasosAprobado.db1af208.svg";